import { ref } from 'vue';

const isOpen = ref(false);
const props = ref({});

export function useConfirmation() {
  /**
   * Shows an async dialog with icon, title and body to the user.
   *
   * @param {string} icon Icon that shows at the top of the dialog. same as q-icon name
   * @param {string} title Title of the dialog.
   * @param {string} body Body of the dialog (can be HTML).
   * @param {string} buttonReject Button text of the dialog.
   * @param {string} buttonResolve Button text of the dialog.
   */
  function showConfirmation({ icon, title, body, buttonReject, buttonResolve } = { icon: '' }) {
    return new Promise((resolve, reject) => {
      props.value = {
        icon,
        title,
        body,
        buttonReject,
        buttonResolve,
        resolveFn: resolve,
        rejectFn: reject
      };
      isOpen.value = true;
    });
  }

  return {
    isOpen,
    props,
    showConfirmation
  };
}
